import { decode } from 'base64-arraybuffer';

import CachedSchemaRepository from '../../infrastructure/schemas/storage/CachedSchemaRepository';

const STYLE_ID = 'schema-icon-styles';
const fonts = new Map<string, Promise<FontFace>>();
let latestLoad = 0;

const registerFont = (font: string, revision: string): Promise<FontFace> => {
  const cachedFont = fonts.get(revision);
  if (cachedFont) return cachedFont;

  const fontFamily = `schema-icons-${revision}`;
  const fontPromise = new FontFace(fontFamily, decode(font))
    .load()
    .then(face => {
      document.fonts.add(face);
      return face;
    })
    .catch(error => {
      fonts.delete(revision);
      throw error;
    });
  fonts.set(revision, fontPromise);
  return fontPromise;
};

const buildIconStyles = (
  fontFamily: string,
  icons: Record<string, string>
): string =>
  [
    `.schema-icon {
      font-family: ${JSON.stringify(fontFamily)} !important;
      font-style: normal;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }`,
    ...Object.entries(icons).map(([name, character]) => {
      const iconClass = CSS.escape(`schema-icon-${name}`);
      return `.${iconClass}::before { content: ${JSON.stringify(character)}; }`;
    }),
  ].join('\n');

export const loadSchemaIconFont = async (): Promise<void> => {
  const loadId = ++latestLoad;
  const iconFont = await new CachedSchemaRepository().getIconFont();
  const fontFamily = `schema-icons-${iconFont.revision}`;

  if (iconFont.font) await registerFont(iconFont.font, iconFont.revision);
  if (loadId !== latestLoad) return;

  let style = document.getElementById(STYLE_ID);
  if (!style) {
    style = document.createElement('style');
    style.id = STYLE_ID;
    document.head.appendChild(style);
  }

  style.textContent = iconFont.font
    ? buildIconStyles(fontFamily, iconFont.icons)
    : '';
};
